module.exports = __webpack_public_path__ + "static/img/fbshareimage.a165a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DOM/EffectFilter/img/fbshareimage.png
// module id = 470
// module chunks = 0